import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrModalConfirmComponent } from '@app/components/pr-modal/pr-modal-confirm/pr-modal-confirm.component';
import { ProductDao } from '@app/dao/product/product.dao';
import { FinancialKnowledgeQustionsService } from '@app/forms/subscription/services/questions/financial-knowledge-qustions.service';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { Subject, take, takeUntil } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
  selector: 'rcda-devis-selection',
  templateUrl: './rcda-devis-selection.component.html',
  styleUrls: ['./rcda-devis-selection.component.scss'],
  standalone: false,
})
export class RcdaDevisSelectionComponent
  extends EaSubscriptionBuilder
  implements OnInit, OnDestroy
{
  @ViewChild(PrModalConfirmComponent, { static: true }) modal: PrModalConfirmComponent;
  private destroy$ = new Subject<void>();
  parameters;
  availableDevis: { value: number; label: string }[] = [];
  availableDevisForAlt1: { value: number; label: string }[] = [];
  availableDevisForAlt2: { value: number; label: string }[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
    private questionsService: FinancialKnowledgeQustionsService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    // Reset : tant qu'on est sur ce step, il est "invalide" pour le ⏩
    this.questionsService.rcdaDevisSelectionVisited = false;

    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;
    this.subscriptionFacade.initForm(this, { ...this.parameters });

    const accountId = Number(pledge.accountId);
    const recommandeId = pledge.products?.[0]?.parameters?.devisRecommandeId;

    const devisList$ =
      pledge.productType === 'INSURANCE'
        ? this.productDao.getMutuelleDevisList(accountId)
        : this.productDao.getPrevoyanceDevisList(accountId);

    devisList$.pipe(take(1)).subscribe(devisList => {
      this.availableDevis = (devisList || [])
        .filter(d => d.id !== recommandeId)
        .map(d => ({
          value: d.id,
          label: `${d.assureurName || ''} — ${d.productName || ''} (${d.titulaireName || ''})`,
        }));
      this.updateFilteredOptions();
    });

    // Filtrer les options quand une sélection change
    const params = this.products?.get('0')?.get('parameters');
    params?.get('devisAlternatif1Id')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.updateFilteredOptions());
    params?.get('devisAlternatif2Id')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.updateFilteredOptions());
  }

  private updateFilteredOptions(): void {
    const params = this.products?.get('0')?.get('parameters');
    const alt1Id = params?.get('devisAlternatif1Id')?.value;
    const alt2Id = params?.get('devisAlternatif2Id')?.value;
    this.availableDevisForAlt1 = this.availableDevis.filter(d => d.value !== alt2Id);
    this.availableDevisForAlt2 = this.availableDevis.filter(d => d.value !== alt1Id);
  }

  onSubmit() {
    const params = this.products?.get('0')?.get('parameters');
    const hasAlt = params?.get('devisAlternatif1Id')?.value || params?.get('devisAlternatif2Id')?.value;

    if (!hasAlt) {
      this.modal.open();
      return;
    }

    this.submitStep();
  }

  confirmSkipDevis() {
    this.submitStep();
  }

  private submitStep() {
    this.questionsService.rcdaDevisSelectionVisited = true;
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
